let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hyz8a")).then(() => parcelRequire('4XEzj'));